var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('sf-data-table',{ref:"resultList",attrs:{"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"currentPage":_vm.pagingInfo.currentPage,"paging":"","excel":"","columns":_vm.columns,"rows":_vm.resultList},on:{"changedPage":_vm.changedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }